module.exports = __webpack_public_path__ + "media/images/hold-button-c92f57edd2d584145fca7911d2906c44.svg";